import React, { useState, useEffect, useContext } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Modal from 'react-modal';

import './insight-report.scss';
import { DashboardHeader } from '../../atoms';
import { AttributeDetailListing, DashContentFooter } from '../../molecules';
import { DashboardContext, UserContext } from '../../../context';
import { DashService } from '../../../services';

function InsightReport() {
  Modal.setAppElement('#root');
  const history = useHistory();
  const params = useParams();

  const [dashData, setDashData] = useState({});
  const { user, setUser } = useContext(UserContext);
  const username = user?.username;
  const userAccessToken = user?.tokens?.accessToken?.jwtToken;
  const [tableRowData, setTableRowData] = useState(null);

  const getReportDetails = async () => {
    const data = { reportId: params.id };
    try {
      const reportDataResponse = await DashService.detailViewReport(
        userAccessToken,
        username,
        data
      );
      setTableRowData(reportDataResponse.data.data);
      getKPIList();
    } catch (error) {
      //console.log(error);
    }
  };

  const getKPIList = async () => {
    const countryListResponse = await DashService.countryList(userAccessToken, username);
    const countryList = countryListResponse.data?.data;
    const kpiListResponse = await DashService.kpiList(userAccessToken, username);
    const kpiList = kpiListResponse.data?.data;
    setDashData(prevDashData => ({
      ...prevDashData,
      kpiList: [...kpiList],
      countryList: [...countryList],
    }));
  };

  useEffect(() => {
    getReportDetails();
  }, []);

  const handleBackClick = event => {
    history.push('/');
  };

  return (
    <DashboardContext.Provider value={{ dashData, setDashData }}>
      <div className="row no-gutters">
        <div className="no-gutters dash-left-wrapper">
          <DashboardHeader />
          {tableRowData ? (
            <AttributeDetailListing
              tableRowData={tableRowData}
              handleBackClick={() => handleBackClick()}
            />
          ) : null}
          <DashContentFooter />
        </div>
      </div>
    </DashboardContext.Provider>
  );
}

export default InsightReport;
